import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Client } from '../../../shared/models/client';
import { DataService } from '../../../shared/services/data-service/data.service';
import { StoreService } from '../../../shared/services/store-service/store.service';
import { EventService } from 'src/app/shared/services/event-service/event.service';

@Component({
  standalone: false,
  selector: 'client-input',
  templateUrl: './client-input.component.html',
  styleUrls: [],
})
export class ClientInputComponent implements OnInit {
  data: Client[] = [];
  isLoading: boolean;
  @Input() serviceId: string;
  @Input() error: string;
  @Input() selectedValue: Client;
  @Output() selectedValueChange = new EventEmitter<Client>();

  constructor(
    private dataService: DataService,
    private eventService: EventService,
    private storeService: StoreService,
    private cdref: ChangeDetectorRef,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.dataService.initClients();
  }
  selectEvent(item: Client) {
    this.selectedValue = item;
    this.selectedValueChange.emit(this.selectedValue);
  }

  async onChangeSearch(val: string) {}

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  async searchClient(clientId: string) {
    this.isLoading = true;
    if (clientId == '') {
      this.isLoading = false;
    } else {
      let client: Client[] = await this.searchClientFromApi(clientId);
      this.eventService.auth0ClientDataIncomingEvent.emit(client);
    }
    this.isLoading = false;
  }

  private async searchClientFromApi(clientId: string) {
    if (clientId || clientId != '') {
      let oktaClient = await this.dataService.getOktaClientByClientId(clientId);
      return [oktaClient];
    }
    return new Array<Client>();
  }
}
